export type Store<T = any> = {
  value: T;
  set: (newValue: Partial<T>) => void;
};

// 修改密码
export enum ModifyPasswordResStatus {
  /** 成功 */
  SUCCESS,
  /** 短信验证码错误 */
  CAPTCHA_ERROR,
  /** 需要图形验证码 */
  NEED_GRAPHIC_CAPTCHA,
  /** 图形验证码错误 */
  GRAPHIC_CAPTCHA_ERROR,
  /** 与旧密码相同 */
  SAME_IN_HISTORY,
  /** 手机号未注册 */
  MOBILE_NOT_EXISTS,
  /** 校验验证码频繁 */
  CAPTCHA_BUSY,
  /** 原密码错误 */
  OLD_PASSWORD_ERROR,
  /** 账号不存在或密码错误 */
  ERROR,
  /** 未知错误 */
  UNKONW
}

export interface ResLoginSuccess {
  /* eslint-disable camelcase */
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
  userId: string;
  state: string | null;
}

export type IResLogin = ResLoginSuccess;

export interface IAuthConfig {
  encryptedPassword: boolean;
}
